module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.f540b423.eot";